﻿<script>
	import { projectSettings } from "../config";
	import { regFormPhone } from "../tealium";
</script>

<header class="no-print">
	<div class="page-header">
		<div class="page-header-warp">
			<div class="page-header-container">
				<div class="page-header-components">
					<a href="https://shine.com.au" title="Shine Lawyers" target="_blank">
						<div class="logo">
							<img
								class="logo"
								src="https://images.ctfassets.net/20mp39y5r2lk/mAk30AlMHQ87xg6hwUA9y/09e406f0786a4a6853cbc29da2fb3692/Shine_Lawyers_Logo.svg"
								alt="Shine Lawyers"
							/>
						</div>
					</a>
					<div class="phone">
						<a
							target="_blank"
							href="tel:{projectSettings.phoneNumber}"
							title="Call {projectSettings.phoneNumber}"
							on:click={() => regFormPhone(projectSettings.phoneNumber)}
						>
							<div class="phone-number">
								<svg
									id="uuid-67d83c8f-d61b-484b-bc31-7c86f891206e"
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 24 24"
									name="Phone"
									class="phone-icon"
									><defs
										><style>
											.uuid-43e75a5b-fff4-4b7c-bda9-4691d537da65 {
												fill: #222222;
											}
											.uuid-43e75a5b-fff4-4b7c-bda9-4691d537da65,
											.uuid-b240d7b9-dab8-4c54-b16c-69264e3373ba {
												fill-rule: evenodd;
											}
											.uuid-b240d7b9-dab8-4c54-b16c-69264e3373ba {
												fill: #ff4814;
											}
										</style></defs
									><path
										id="uuid-4eb7f896-8890-4522-ba60-51e298f63be1"
										class="uuid-b240d7b9-dab8-4c54-b16c-69264e3373ba"
										d="M17.63,24h0c-3.12,0-6.87-2.16-11.17-6.42C3.52,14.65,0,10.34,0,6.47,0,4.87,.56,3.5,1.67,2.39c.01-.01,.02-.02,.03-.03,.1-.09,.11-.1,1.49-1.16l.35-.26c.37-.28,.67-.51,.73-.56,.69-.55,1.69-.5,2.31,.12l3.82,3.82c.61,.61,.69,1.56,.19,2.27l-2.27,2.78,6.67,6.58,2.81-2.23c.73-.52,1.67-.45,2.28,.15l3.41,3.41c.65,.64,.68,1.69,.1,2.38-.12,.19-.33,.49-.71,1.05q-1.01,1.48-1.14,1.61c-1.12,1.12-2.5,1.68-4.1,1.68h0Z"
									></path><path
										id="uuid-9318059f-eacc-47d2-baf3-9b8d18d5dd0d"
										class="uuid-43e75a5b-fff4-4b7c-bda9-4691d537da65"
										d="M3.13,3.84c-.72,.72-1.07,1.58-1.07,2.63,0,2.47,2.08,5.9,5.86,9.65,4.85,4.81,7.96,5.83,9.72,5.83h0c1.05,0,1.92-.35,2.65-1.08,.02-.03,.27-.4,.89-1.31,.29-.42,.56-.83,.68-1l-3.02-3.02-3.27,2.6c-.41,.32-.99,.29-1.36-.07l-7.99-7.88c-.38-.37-.41-.97-.07-1.38l2.63-3.21-3.42-3.42c-.14,.11-.33,.26-.55,.42l-.35,.26c-.97,.74-1.22,.93-1.31,1h0Z"
									></path></svg
								>
								{projectSettings.phoneNumber}
							</div>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</header>

<style>
	header {
		/*		margin-bottom: var(--height-header);
		margin-bottom: 40px;
*/
		transition: all 0.24s ease 0s;
	}

	header .page-header {
		width: 100vw;
		top: 0px;
		z-index: var(--z-index-top);
	}

	header .page-header-warp {
		background-color: var(--color-charcoal);
		display: flex;
		-webkit-box-align: center;
		align-items: center;
		width: 100vw;
		height: var(--height-header);
	}

	header .page-header-container {
		width: 100%;
		max-width: 1440px;
		padding: 0px 30px;
		margin: 0px auto;
	}

	header .page-header-components {
		display: flex;
		-webkit-box-align: center;
		align-items: center;
		-webkit-box-pack: justify;
		justify-content: space-between;
		width: 100%;
	}

	header .page-header-components a {
		color: inherit;
		text-decoration: none;
		outline: none;
	}

	header .logo {
		position: relative;
		margin-top: -3px;
		height: 45px;
		width: 100%;
	}

	header .logo img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	header .phone {
		display: flex;
		-webkit-box-align: center;
		align-items: center;
	}

	header .phone a {
		display: flex;
		-webkit-box-pack: center;
		justify-content: center;
		flex-direction: column;
		height: 100%;
		min-width: fit-content;
		color: var(--color-primary);
	}

	header .phone-icon {
		margin-right: 2px;
		width: 1rem;
		height: 1rem;
		min-width: 1rem;
		min-height: 1rem;
	}

	:global(header .phone-number a) {
		color: #fff;
	}

	@media (max-width: 1024px) {
		header .logo {
			height: 37px;
			width: 170px;
		}

		header .phone a {
			width: fit-content;
			margin: 20px 0px;
		}
	}

	@media (max-width: 400px) {
		header .page-header-container {
			padding: 0px 16px;
		}
	}
</style>
